module.exports = __webpack_public_path__ + "static/img/circle.c5c03d61.svg";